<app-modal>
  <div class="if-modal-title">
    <h3 class="bdf-modal-title">BDF Generation — {{ project()?.name ?? '' }}</h3>
  </div>

  <div class="if-modal-content">
    @if (project() && !project()!.isMaster) {
      <ul class="bdf-child-list" role="list">
        <li class="bdf-row bdf-row--child">
          <div class="bdf-row__main">
            <div class="bdf-row__name">BDF mesh</div>
            <div class="bdf-row__status" role="status" aria-live="polite" aria-atomic="true">
              <app-bdf-row-pill
                size="xxs"
                [status]="singleStatus()?.status ?? 'idle'"
                [showAll]="true">
              </app-bdf-row-pill>
              @if (singleStatus()?.highRes) {
                <app-bdf-highres-badge></app-bdf-highres-badge>
              }
              @if (singleStatus()?.status === 'error' && singleStatus()?.error) {
                <span class="bdf-row__error">{{ singleStatus()!.error }}</span>
              }
            </div>
          </div>
          <div class="bdf-row__actions">
            @if (singleStatus()?.status === 'queued' || singleStatus()?.status === 'running') {
              <app-button
                variant="ghost"
                size="xs"
                ghostType="error"
                [disabled]="isActionBusy('cancel:' + project()!.id)"
                (click)="onCancelSingle()">
                Stop
              </app-button>
            } @else if (singleStatus()?.status === 'done') {
              <app-button
                variant="outline"
                size="xs"
                [disabled]="isActionBusy('download:' + project()!.id)"
                (click)="onDownloadSingle()">
                Download
              </app-button>
              <app-button
                variant="ghost"
                size="xs"
                [disabled]="isActionBusy('generate:' + project()!.id)"
                [attr.aria-label]="'Regenerate BDF'"
                (click)="onRegenerateSingle()">
                Regenerate
              </app-button>
            } @else {
              <app-button
                variant="outline"
                size="xs"
                [disabled]="generateDisabled()"
                (click)="onGenerate()">
                Generate
              </app-button>
            }
          </div>
        </li>
      </ul>
    } @else {
      <p class="bdf-master-hint" id="bdf-master-hint">
        Select one or more manufacturing cases to generate BDF files.
      </p>
      <ul class="bdf-child-list" role="list" aria-describedby="bdf-master-hint">
        @for (child of children(); track child.id) {
          @let childJob = getChildStatus(child.id)();
          <li class="bdf-row bdf-row--child">
            <div class="bdf-row__main">
              <app-checkbox
                class="bdf-row__check"
                [label]="child.methodLabel"
                [ngModel]="isChildSelected(child.id)"
                (ngModelChange)="toggleChild(child.id, $event)">
              </app-checkbox>
              <div class="bdf-row__status" role="status" aria-live="polite" aria-atomic="true">
                <app-bdf-row-pill
                  size="xxs"
                  [status]="childJob?.status ?? 'idle'"
                  [showAll]="true">
                </app-bdf-row-pill>
                @if (childJob?.highRes) {
                  <app-bdf-highres-badge></app-bdf-highres-badge>
                }
              </div>
            </div>
            <div class="bdf-row__actions">
              @if (childJob?.status === 'queued' || childJob?.status === 'running') {
                <app-button
                  variant="ghost"
                  size="xs"
                  ghostType="error"
                  [disabled]="isActionBusy('cancel:' + child.id)"
                  [attr.aria-label]="'Stop BDF generation for ' + child.methodLabel"
                  (click)="onCancelChild(child.id)">
                  Stop
                </app-button>
              } @else if (childJob?.status === 'done') {
                <app-button
                  variant="outline"
                  size="xs"
                  [disabled]="isActionBusy('download:' + child.id)"
                  [attr.aria-label]="'Download BDF for ' + child.methodLabel"
                  (click)="onDownloadChild(child.id)">
                  Download
                </app-button>
                <app-button
                  variant="ghost"
                  size="xs"
                  [disabled]="isActionBusy('generate:' + (project()?.id ?? child.id))"
                  [attr.aria-label]="'Regenerate BDF for ' + child.methodLabel"
                  (click)="onRegenerateChild(child.id)">
                  Regenerate
                </app-button>
              }
            </div>
          </li>
        }
      </ul>
    }

    <div class="bdf-options">
      <app-checkbox
        class="bdf-high-res-toggle"
        label="High resolution mesh (slower)"
        [ngModel]="highRes()"
        (ngModelChange)="toggleHighRes($event)">
      </app-checkbox>
    </div>
  </div>

  <div class="if-modal-actions">
    <app-button variant="ghost" size="sm" (click)="onClose()">Cancel</app-button>
    @if (project()?.isMaster) {
      <app-button
        variant="outline"
        size="sm"
        [disabled]="generateDisabled()"
        (click)="onGenerate()">
        Generate Selected
      </app-button>
      <app-button
        class="bdf-bundle-button"
        variant="primary"
        size="sm"
        [disabled]="!bundleReady() || bundleBusy() || isActionBusy('bundle:' + project()!.id)"
        (click)="onDownloadBundle()">
        @if (bundleBusy()) {
          <app-inline-spinner aria-hidden="true"></app-inline-spinner>
          Preparing ZIP…
        } @else {
          Download Selected as ZIP
        }
      </app-button>
    }
  </div>
</app-modal>
